import accountDao from '../../../../dao/smbpartner/accountDao';
import {loadAuth} from '../../../../components/auth/reducers';

const UPDATE_PARTNER = 'pages/partner/settings/accountinfo/UPDATE_PARTNER';
const UPDATE_PARTNER_SUCCESS =
  'pages/partner/settings/accountinfo/UPDATE_PARTNER_SUCCESS';
const INIT_PAYMENT = 'pages/partner/settings/accountinfo/INIT_PAYMENT';
const SET_PAYMENT = 'pages/partner/settings/accountinfo/SET_PAYMENT';

const initialState = {
  showPwdField: false,
  originPayment: {
    paymentType: '',
    paymentAccount: '',
  },
  payment: {
    paymentType: '',
    paymentAccount: '',
  },
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case UPDATE_PARTNER:
      return {
        ...state,
      };
    case UPDATE_PARTNER_SUCCESS:
      return {
        ...state,
      };
    case INIT_PAYMENT:
      return {
        ...state,
        originPayment: {
          ...state.originPayment,
          ...action.payment,
        },
        payment: {
          ...state.payment,
          ...action.payment,
        },
      };
    case SET_PAYMENT:
      return {
        ...state,
        payment: {
          ...state.payment,
          ...action.payment,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export function initPayment(customer) {
  return {
    type: INIT_PAYMENT,
    payment: {
      paymentType: customer.paymentType,
      paymentAccount: customer.paymentAccount,
    },
  };
}

export function setPayment(paymentType) {
  return (dispatch, getState) => {
    const originPayment = getState().pages.partner.settings.accountinfo
      .originPayment;
    return dispatch({
      type: SET_PAYMENT,
      payment: {
        paymentType: paymentType,
        paymentAccount:
          paymentType === originPayment.paymentType
            ? originPayment.paymentAccount
            : '',
      },
    });
  };
}

export function updatePartner(partner) {
  return dispatch => {
    dispatch({type: UPDATE_PARTNER});
    return accountDao.updatePartner(partner).then(json => {
      dispatch({type: UPDATE_PARTNER_SUCCESS});
      dispatch(loadAuth());
      return json;
    });
  };
}
